import { Page } from "@tfg/ui"

export const SupplierFAQWrapper = () => {
  return <Page title="FAQ" />
}
